import { HotelReservedCardDetailPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-detail/hotel-reserve-card-detail.types";
import { useHotelReserveCard } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card.hook";
import { isFilled } from "@website/utils/is-filled";
import { useRouter } from "next/router";
import {
  BaseSyntheticEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";

export const useHotelReserveCardDetail = (
  properties: HotelReservedCardDetailPropertiesType
) => {
  const { facilities, roomDetail, availableRooms, rackIncluded } = properties;
  const { hotelReserveCardFooterProps } = useHotelReserveCard(properties);
  const selectedTab = useRef(roomDetail?.tabSelected);
  const showCancellation = availableRooms || rackIncluded;
  const router = useRouter();

  const defaultMenuItems = useMemo(
    () => [
      ...(isFilled(facilities)
        ? [
            {
              title: "امکانات",
              id: "facilities",
              selected: selectedTab.current === "facilities"
            }
          ]
        : []),
      {
        title: "تقویم اتاق",
        id: "roomCalendar",
        selected: selectedTab.current === "roomCalendar"
      },
      ...(isFilled(roomDetail?.filters) &&
      router?.query["filter_attitude"] &&
      !isFilled(roomDetail?.comments)
        ? [
            {
              title: "نظرات",
              id: "comments",
              selected: selectedTab.current === "comments"
            }
          ]
        : isFilled(roomDetail?.comments)
          ? [
              {
                title: "نظرات",
                id: "comments",
                selected: selectedTab.current === "comments"
              }
            ]
          : []),
      ...(showCancellation
        ? [
            {
              title: "قوانین کنسلی",
              selected: selectedTab.current === "cancellation",
              id: "cancellation"
            }
          ]
        : [])
    ],
    [facilities, roomDetail?.comments, roomDetail?.filters, router?.query]
  );

  const [menuItems, setMenuItems] = useState(defaultMenuItems);

  useEffect(() => {
    setMenuItems(defaultMenuItems);
  }, [defaultMenuItems, roomDetail?.showRoomDetail, selectedTab]);

  useEffect(() => {
    selectedTab.current = roomDetail?.tabSelected;
  }, [roomDetail?.showRoomDetail, roomDetail?.tabSelected]);

  const menuItemClick = useCallback((event: BaseSyntheticEvent) => {
    setMenuItems((previousState) =>
      previousState.map((value) => {
        if (value.id === event.target.id)
          return {
            ...value,
            selected: true
          };
        return {
          ...value,
          selected: false
        };
      })
    );
    selectedTab.current = event.target?.id;
  }, []);

  return {
    menuItems,
    onClick: menuItemClick,
    isLoading: roomDetail?.isCalendarLoading,
    hotelRoomCalendar: {
      calendar: roomDetail?.calendar ?? [],
      view: "mobile" as const,
      suggestions: roomDetail?.suggestions ?? [],
      isLabelToTop: roomDetail?.isLabelToTop || false
    },
    hotelReserveCardDetailComments: {
      comments: roomDetail?.comments ?? [],
      filters: roomDetail?.filters,
      onLoadFilter: roomDetail?.onLoadFilter,
      onLoadMore: roomDetail?.onLoadMoreComments,
      isLoading: roomDetail?.isCommentsLoading,
      isInsideDetail: true
    },
    hotelReserveCardFooterProperties: {
      ...hotelReserveCardFooterProps,
      view: "mobile" as const
    },
    hotelReserveCardDetailFacilitiesProperties: {
      facilities
    }
  };
};
